import axios from 'axios';
import { BASE_URL } from '@/services/api';

export const NOT_LOGGED_MESSAGE = "Couldn't save. Check your connection and retry"

function postLog(data, token) {
  return axios({
    method: 'post',
    url: `${BASE_URL}/pwa_saved_company_logs/`,
    headers: {
      'Authorization': `Token ${token}`,
      'Content-Type': 'application/json'
    },
    data,
    timeout: 10000,
  })
}

// Audit log for saving companies to the phone. Call before saving, and only save
// if this returns true, so nothing is saved without a log row. Retries once.
export async function logSavedCompanies(companyIds, token) {
  const data = { company_ids: companyIds }
  try {
    await postLog(data, token)
    return true
  } catch (error) {
    try {
      await postLog(data, token)
      return true
    } catch (error) {
      console.log(error)
      return false
    }
  }
}
